import { partnerProductOrderItemPageState } from "@/atoms/item/partner-product-order-item-page-state";
import { PaginationSize } from "@/common/enum/pagination-size";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useRecoilValue } from "recoil";
import { profileState } from "../../../atoms/user/profile-state";
import { CustomCell } from "../CustomCell";
import { PartnerProductOrderTableFooter } from "./PartnerProductOrderTableFooter";
import { PartnerProductOrderTableRow } from "./PartnerProductOrderTableRow";

const headers: TableHeader[] = [
  { title: "카테고리", width: "w-[142px]" },
  { title: "상품명", width: "w-[355px]" },
  { title: "기본 할인", width: "w-[78px]" },
  { title: "인센티브 할인", width: "w-[88px]" },
  { title: "판매가 (VAT 포함)", width: "w-[136px]" },
];

export const PartnerProductOrderTable = () => {
  const profile = useRecoilValue(profileState);

  const page = useRecoilValue(partnerProductOrderItemPageState);
  const items = page.contents;
  const totalElements = page.totalElements;
  const currentPage = page.currentPage;
  const startIndex = totalElements - (currentPage - 1) * PaginationSize.SIZE_12;

  console.log("pagedata", page);

  return (
    <div className="w-[1112px] overflow-x-auto rounded-lg border">
      <Table>
        <Table.Head className="p-0 border-b">
          <Table.HeadCell className="w-[56px]" />
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px]"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
          <Table.HeadCell className="w-[193px]" />
        </Table.Head>
        <Table.Body className="divide-y">
          {items.map((item, index) => (
            <PartnerProductOrderTableRow
              key={item.id}
              data={item}
              gradeDiscountRate={profile?.grade.discountRate || 0}
              index={index}
              startIndex={startIndex}
            />
          ))}
          <PartnerProductOrderTableFooter
            headersLength={Object.values(headers).length + 2}
          />
        </Table.Body>
      </Table>
    </div>
  );
};
